import React from 'react';
import { motion } from 'framer-motion';
import { FaPhoneAlt, FaWhatsapp, FaCalendarCheck } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const MobileBottomBar = () => {
    const navigate = useNavigate();

    const handleCall = () => {
        window.location.href = 'tel:+918076353837';
    };

    const handleWhatsApp = () => {
        window.open('https://wa.me/918076353837', '_blank');
    };

    const handleBook = () => {
        navigate('/contact');
    };

    return (
        <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-[100] pb-safe">
            <div className="grid grid-cols-3 h-16">
                <button
                    onClick={handleCall}
                    className="flex flex-col items-center justify-center gap-1 active:bg-gray-50 transition-colors"
                >
                    <div className="bg-blue-50 text-blue-600 p-2 rounded-full">
                        <FaPhoneAlt className="text-lg" />
                    </div>
                    <span className="text-xs font-medium text-gray-600">Call</span>
                </button>

                <button
                    onClick={handleWhatsApp}
                    className="flex flex-col items-center justify-center gap-1 active:bg-gray-50 transition-colors"
                >
                    <div className="bg-green-50 text-green-600 p-2 rounded-full">
                        <FaWhatsapp className="text-xl" />
                    </div>
                    <span className="text-xs font-medium text-gray-600">WhatsApp</span>
                </button>

                <button
                    onClick={handleBook}
                    className="flex flex-col items-center justify-center gap-1 bg-primary-600 text-white"
                >
                    <FaCalendarCheck className="text-lg mb-0.5" />
                    <span className="text-xs font-bold">Book Now</span>
                </button>
            </div>
            {/* Safe area spacer for iPhone X+ home indicator */}
            <div className="h-safe-area bg-white" />
        </div>
    );
};

export default MobileBottomBar;
